import { render, staticRenderFns } from "./question_details.vue?vue&type=template&id=26105468&scoped=true"
import script from "./question_details.vue?vue&type=script&lang=js"
export * from "./question_details.vue?vue&type=script&lang=js"
import style0 from "./question_details.vue?vue&type=style&index=0&id=26105468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26105468",
  null
  
)

export default component.exports